import React, { useEffect, useState } from "react";


import ReactDOM from "react-dom";

import Navbar from "./Navbar";
import Footer from "./Footer";
import {
  Button,
  MenuItem,

  Select,
  Dialog,
  DialogContent,
  IconButton,
  Typography,

} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import heroImage from "../images/login-hero.png";
import { useNavigate } from "react-router-dom";

// import RegisterBasicDetails from "./basic-details/RegisterBasicDetails";
import RegisterBasicDetails from "./newRegistrationFlow/RegisterBasicDetails";




export const Register = () => {
  const navigate = useNavigate();
  const [profileByList, setProfileByList] = useState([]);
  const [maritalStatusList, setMaritalStatusList] = useState([]);
  const [heightList, setHeightList] = useState([]);
  const [popup, setPopup] = useState({ show: false, type: "", message: "" });
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [showOtpForm, setShowOtpForm] = useState(false);
  // const [registrationData, setRegistrationData] = useState(null);

  // const [registrationSection, setRegistrationSection] = useState("BASIC");

  const [registrationData, setRegistrationData] = useState(() => {
    const savedData = localStorage.getItem("register_registration_data");
    return savedData ? JSON.parse(savedData) : null;
  });




  useEffect(() => {
  const token = localStorage.getItem("token");

  if (!token) {
    navigate("/otpLogin?mode=register", { replace: true });
  }
}, [navigate]);


useEffect(() => {
  const progress = localStorage.getItem("registrationProgress");

  const COMPLETED_STEPS = [
    "COUMMUNITY_DETAILS_CHECK",
    "FAMILY_DETAILS_CHECK",
    "SIBLING_DETAILS_CHECK",
    "ABOUT_ME_CHECK",
    "ABOUT_LIFE_PARTNER_CHECK",
    "ABOUT_PARENT_CHECK",
    "COMPLETED",
  ];

  if (COMPLETED_STEPS.includes(progress)) {
    navigate("/my_matches");
  }
}, [navigate]);




  const [phone, setPhone] = useState("");

  // 👇 Replace your `const isMobile = window.innerWidth <= 500;`
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 500);
  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= 500);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  useEffect(() => {
    const handler = () => console.log("FORM SUBMITTED!");
    window.addEventListener("submit", handler);

    return () => window.removeEventListener("submit", handler);
  }, []);





  const inputTextStyle = {
    width: "100%",
    height: "100%",
    border: "none",
    outline: "none",
    background: "transparent",
    fontSize: "16px",
    fontWeight: 500,
    color: "#333", // Dark input text
  };

  const InputBox = ({
    name,
    value,
    onChange,
    placeholder,
    select,
    children,
    disabled = false,
    type = "text",
  }) => (
    <div
      style={{
        borderRadius: "10px",
        backgroundColor: "#f5fcfe",
        border: "1px solid #d4d4d4",
        height: "40px",
        display: "flex",
        alignItems: "center",
        padding: "0 15px",
        fontFamily: "Montserrat",
      }}
    >
      {select ? (
        <Select
          name={name}
          value={value}
          onChange={onChange}
          displayEmpty
          variant="standard"
          disableUnderline
          fullWidth
          disabled={disabled}
          MenuProps={{
            PaperProps: {
              style: {
                fontFamily: "Montserrat, sans-serif",
                backgroundColor: "#f5fcfe",
                borderRadius: "10px",
                boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
              },
            },
          }}
          sx={{
            fontSize: "16px",
            color: "#333",
            fontFamily: "Montserrat, sans-serif",
            "& .MuiSelect-select": {
              fontFamily: "Montserrat, sans-serif",
              padding: "0 !important",
              fontFamily: "Montserrat",
            },
          }}
        >
          <MenuItem
            value=""
            disabled
            sx={{
              fontFamily: "Montserrat, sans-serif",
            }}
          >
            {placeholder}
          </MenuItem>

          {children}
        </Select>
      ) : (
        <input
          name={name}
          type={type}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          style={inputTextStyle}
        />
      )}
    </div>
  );

  return (
    <>
      <Navbar hideAuthButtons />
      <div
        style={{
          width: "100%",
          minHeight: "100vh",
          background: "linear-gradient(180deg, #fff8f0 0%, #fff4ef 100%)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "120px 20px 60px",
        }}
      >
        <div
          style={{
            width: "100%",
            maxWidth: "1050px",
            background: "#fff",
            borderRadius: "20px",
            overflow: "hidden",
            boxShadow: "0 4px 15px rgba(0,0,0,0.08)",
            padding: isMobile ? "24px 0 0 0" : "30px 30px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >




          {/* Inner flex row */}
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              alignItems: "stretch",
              width: "100%",
              gap: "0px",
              padding: isMobile ? "0 14px 18px" : "0",
            }}
          >
            {/* LEFT SIDE */}
            <div
              style={{
                flex: isMobile ? "1 1 100%" : "0 0 450px",
                justifyContent: "center",
                alignItems: isMobile ? "center" : "start",
                padding: isMobile ? "25px 8px" : "15px 10px 30px 40px",
                zIndex: 999,
              }}
            >
              <div
                style={{
                  position: "relative",
                  width: "100%",
                  maxWidth: isMobile ? "330px" : "400px",
                  borderRadius: "16px",
                  overflow: "hidden",
                }}
              >
                <img
                  src={heroImage}
                  alt="Hero"
                  style={{
                    width: "100%",
                    height: isMobile ? "230px" : "550px",
                    borderRadius: "16px",
                    objectFit: "cover",
                  }}
                />
                <div
                  style={{
                    position: "absolute",
                    inset: 0,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: isMobile ? "start" : "start",
                    alignItems: "center",
                    textAlign: "center",
                    color: "#fff",
                    fontFamily: "Montserrat",
                    padding: isMobile ? "10px" : "20px",
                  }}
                >
                  <h2
                    style={{
                      fontSize: isMobile ? "16px" : "22px",
                      fontWeight: 700,
                      marginBottom: isMobile ? "4px" : "6px",
                      lineHeight: isMobile ? "20px" : "26px",
                    }}
                  >
                    Welcome to IND Matrimony
                  </h2>
                  <p
                    style={{
                      fontSize: isMobile ? "12px" : "14px",
                      margin: 0,
                      opacity: 0.9,
                      lineHeight: isMobile ? "14px" : "22px",
                    }}
                  >
                    We provide the best match making service
                  </p>
                </div>
              </div>
            </div>


            {/* RIGHT SIDE */}
            <div
              style={{
                flex: "1 1 500px",
                padding: isMobile ? "20px 10px" : "10px 0px 0px 15px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >

               <RegisterBasicDetails />


            </div>
          </div>
        </div>
      </div>

      <Dialog
        open={popup.show}
        onClose={() => setPopup({ show: false, type: "", message: "" })}
        PaperProps={{
          style: {
            borderRadius: "16px",
            padding: "10px",
            minWidth: "300px",
            maxWidth: "350px",
            textAlign: "center",
            borderTop:
              popup.type === "success"
                ? "5px solid #4CAF50"
                : "5px solid #ff3c3c",
          },
        }}
        sx={{ zIndex: 2001 }} // Ensure it sits on top of everything
      >
        <IconButton
          onClick={() => setPopup({ show: false, type: "", message: "" })}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          <Typography
            variant="h6"
            sx={{
              color: popup.type === "success" ? "#4CAF50" : "#ff3c3c",
              fontWeight: "bold",
              mb: 1,
              fontFamily: "Montserrat",
            }}
          >
            {popup.type === "success" ? "Success!" : "Error"}
          </Typography>
          <Typography
            variant="body1"
            sx={{ color: "#555", fontFamily: "Montserrat" }}
          >
            {popup.message}
          </Typography>
        </DialogContent>
      </Dialog>

      {showSuccessPopup && (
        <div
          style={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "#fff",
            borderRadius: "12px",
            padding: "20px 40px",
            boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
            textAlign: "center",
            zIndex: 1000,
            borderTop: "5px solid #4CAF50",
          }}
        >
          <h4
            style={{
              margin: 0,
              color: "#4CAF50",
            }}
          >
            Success!
          </h4>
          <p style={{ margin: "10px 0", color: "#555" }}>
            {registrationData?.message || "Registered successfully!"}
          </p>
          <Button
            onClick={() => {
              setShowSuccessPopup(false);
              setShowOtpForm(true);
            }}
            style={{
              borderRadius: "50px",
              background:
                "linear-gradient(rgba(255, 255, 255, 0.3), rgba(255, 255, 255, 0.22)), linear-gradient(90deg, #f78c25, #ff3c3c)",
              color: "#fff",
              fontWeight: 600,
              fontSize: "16px",
              height: "40px",
              textTransform: "none",
              fontFamily: "Montserrat",
              boxShadow: "0 4px 8px rgba(255,60,60,0.3)",
            }}
          >
            OK
          </Button>
        </div>
      )}

      <Footer />

      {/* <OtpVerification
        open={showOtpForm}
        onClose={() => setShowOtpForm(false)}
        phone={phone}
        token={registrationData?.token || ""} // OR remove entirely
        onSuccess={() => {
          setShowOtpForm(false);
          setCurrentStep(2);
          localStorage.setItem("register_current_step", 2);
        }}
        onError={(msg) => {
          showPopup("error", msg, false); // Disable auto-close for OTP errors
        }}
      /> */}

      <style>
        {`
  input::placeholder {
    color: rgba(79, 79, 79, 0.55); /* Light grey placeholder */
    font-weight: 400;
  }
`}
      </style>
    </>
  );
};
